{
  "comment": "Mission 3 comms (S13 owns). Node shape: src/story/schemas.ts commsNodeSchema (a speaker, 1–3 lines, 1–4 replies; \"Show [log]\" replies; a reply without next ends the conversation). Node ids are unique across every comms file. Voice: docs/story/drafts/2026-09-29-m7-voice-samples.md (Kell short and transactional; Okafor precise, one clause too long; Voss courteous, never confesses, no offer). m3.okafor.trust's 'show' reply hands over to okafor.ts proveTrust, which opens m3.okafor.reading, m3.okafor.no_proof or m3.okafor.no_rig. Text placeholders until the naming and voice pass.",
  "nodes": [
    {
      "id": "m3.kell.offer",
      "speaker": "kell",
      "lines": [
        "There's an old man you should talk to. He won't want to talk to you.",
        "He keeps a relay out past the deep lanes. It's been down since spring. Fix it and he's out of excuses."
      ],
      "replies": [
        { "id": "who", "text": "Who is he?", "next": "m3.kell.offer.who" },
        { "id": "ok", "text": "Send me the lane." }
      ]
    },
    {
      "id": "m3.kell.offer.who",
      "speaker": "kell",
      "lines": [
        "He measured things for the Rush, back when there was money to measure things.",
        "Then they gave him a relay to look after. Ask him the rest."
      ],
      "replies": [{ "id": "ok", "text": "Send me the lane." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.bulletin.offer",
      "speaker": "mutualArchivist",
      "lines": [
        "Bulletin item, relay maintenance: the old lab relay on the deep lane is reported down.",
        "One resident at the far end. No service contract on file. Parts at your own cost."
      ],
      "replies": [{ "id": "ok", "text": "Log it to my nav." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.okafor.meet",
      "speaker": "okafor",
      "lines": [
        "You fixed my relay. Nobody asked you to, which means somebody asked you to.",
        "Kell. Kell sends people when he wants something measured and doesn't trust his own instruments."
      ],
      "replies": [
        { "id": "test", "text": "He said you'd test me.", "next": "m3.okafor.trust" },
        { "id": "who", "text": "I'm here about the Rush.", "next": "m3.okafor.trust" }
      ]
    },
    {
      "id": "m3.okafor.trust",
      "speaker": "okafor",
      "lines": [
        "Tethys says the old seams are quiet. Bring me a reading of something of theirs that's still pulling stone.",
        "Recent. Numbers, not a summary. I'll know if it's old."
      ],
      "replies": [
        { "id": "show", "text": "Put what I have on your screen." },
        { "id": "later", "text": "I'll come back with one." }
      ]
    },
    {
      "id": "m3.okafor.no_proof",
      "speaker": "okafor",
      "lines": ["That isn't a reading. That's a story about one.", "Come back with numbers."],
      "replies": [{ "id": "ok", "text": "I will." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.okafor.no_rig",
      "speaker": "okafor",
      "lines": [
        "Nothing of theirs pulling anywhere? Then someone will put a rig out quietly. They always do.",
        "Kell will hear where. Read it, and bring me the numbers."
      ],
      "replies": [{ "id": "ok", "text": "I'll find it." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.okafor.not_here",
      "speaker": "kell",
      "lines": ["He's not there to show it to. Get him back first."],
      "replies": [{ "id": "ok", "text": "Understood." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.okafor.reading",
      "speaker": "okafor",
      "lines": [
        "Transit variance, point four. Lagging the cut by nine minutes.",
        "That's a clean lag. Cleaner than anything I had."
      ],
      "replies": [
        { "id": "test", "text": "Kell said you'd test me.", "next": "m3.okafor.reading.test" },
        { "id": "tell", "text": "What does it tell you?", "next": "m3.okafor.reading.tell" },
        {
          "id": "show",
          "text": "Show him the paperwork that moved him.",
          "show": { "thread": "report", "link": "coverup" },
          "next": "m3.okafor.reading.transfer"
        }
      ]
    },
    {
      "id": "m3.okafor.reading.test",
      "speaker": "okafor",
      "lines": ["It wasn't for you. I've had a meter in a drawer for thirty years. I never once took it out."],
      "replies": [{ "id": "go", "text": "And now?", "next": "m3.okafor.lab" }]
    },
    {
      "id": "m3.okafor.reading.tell",
      "speaker": "okafor",
      "lines": [
        "I had fourteen cuts. I could have had four hundred.",
        "Fourteen. Over a fortnight. I had the week to take more."
      ],
      "replies": [{ "id": "go", "text": "Then do something with it now.", "next": "m3.okafor.lab" }]
    },
    {
      "id": "m3.okafor.reading.transfer",
      "speaker": "okafor",
      "lines": ["Brisk. Upkeep. They gave me a relay to keep so I'd have something to do with my hands."],
      "replies": [{ "id": "go", "text": "What did you leave behind?", "next": "m3.okafor.lab" }]
    },
    {
      "id": "m3.okafor.lab",
      "speaker": "okafor",
      "lines": ["The report is in my old lab. Sealed core, bay four, under the bench they told me to decommission."],
      "replies": [
        { "id": "why", "text": "Why sign the weaker one?", "next": "m3.okafor.lab.why" },
        { "id": "hearing", "text": "Would you say that at a hearing?", "next": "m3.okafor.lab.hearing" },
        { "id": "go", "text": "I'll get the core." }
      ]
    },
    {
      "id": "m3.okafor.lab.why",
      "speaker": "okafor",
      "lines": [
        "\"Possible\" gets read. \"Certain\" gets someone transferred.",
        "I thought read was better. I was wrong about who they'd transfer."
      ],
      "replies": [{ "id": "go", "text": "I'll get the core." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.okafor.lab.hearing",
      "speaker": "okafor",
      "lines": ["Ask me when you've read it. Then ask me again."],
      "replies": [{ "id": "go", "text": "I'll get the core." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.voss.contact",
      "speaker": "voss",
      "lines": [
        "I'm not calling to buy anything. I'd like you to know who you're talking to.",
        "You've been reading old paper. Everyone who reads old paper finds a villain in it. It's the format."
      ],
      "replies": [
        { "id": "column", "text": "Column Nine waited eleven days.", "next": "m3.voss.column" },
        { "id": "paper", "text": "Then tell me what isn't on the paper.", "next": "m3.voss.paper" },
        { "id": "close", "text": "(close the channel)" }
      ]
    },
    {
      "id": "m3.voss.column",
      "speaker": "voss",
      "lines": [
        "Column Nine waited. Forty-one hulls didn't.",
        "The fund moved 4,872 people out. Column Nine held 4,310. The sums are on file, and you can check them."
      ],
      "replies": [{ "id": "go", "text": "(listen)", "next": "m3.voss.close" }]
    },
    {
      "id": "m3.voss.paper",
      "speaker": "voss",
      "lines": [
        "Payroll. Four thousand families outside the gate ate on what got through before it shut.",
        "Every survey we trusted said the gate ran on a cycle."
      ],
      "replies": [{ "id": "go", "text": "(listen)", "next": "m3.voss.close" }]
    },
    {
      "id": "m3.voss.close",
      "speaker": "voss",
      "lines": [
        "What got out paid for the survey that reopened the gate. It pays for the Carrow Refinery.",
        "I've made this case to three commissions. I'm making it once to you, because you've done the reading.",
        "Good evening."
      ],
      "replies": [{ "id": "close", "text": "(the channel closes)" }]
    },
    {
      "id": "m3.patrol.inspection",
      "speaker": "charterPatrol",
      "lines": [
        "Charter Patrol. Hold position and open your hold for inspection.",
        "Unregistered salvage from research sites is logged with the Charter Office."
      ],
      "replies": [{ "id": "ack", "text": "Acknowledged." }]
    },
    {
      "id": "m3.patrol.logged",
      "speaker": "charterPatrol",
      "lines": ["Sealed core, origin research derelict. Logged. Proceed."],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.patrol.evade",
      "speaker": "charterPatrol",
      "lines": ["Hold reads clean. Proceed."],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.patrol.evade_caught",
      "speaker": "charterPatrol",
      "lines": ["Second pass. Your hold mask reads on the hard scan. Smuggling count logged to your registry."],
      "variants": { "corporation": ["Second pass. Your hold mask reads on the hard scan. Smuggling count logged to your company's registry."] },
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.patrol.run",
      "speaker": "charterPatrol",
      "lines": ["Vessel, you are ordered to hold. Your registry is logged."],
      "variants": { "corporation": ["Vessel, you are ordered to hold. Your company's registry is logged."] },
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.okafor.testify",
      "speaker": "okafor",
      "lines": [
        "You've read it. Then you know what I sent up, and what I didn't.",
        "I'll say it at a hearing, in my own words. I'd ask you to leave my name off it. I know what that asks of you."
      ],
      "replies": [
        { "id": "why", "text": "Why off the record?", "next": "m3.okafor.testify.why" },
        {
          "id": "drafts",
          "text": "Show him the withdrawn drafts.",
          "show": { "thread": "report", "link": "knowledge" },
          "next": "m3.okafor.drafts"
        },
        { "id": "ok", "text": "Let me think." }
      ]
    },
    {
      "id": "m3.okafor.testify.why",
      "speaker": "okafor",
      "lines": ["Because the last time my name was on something, they moved me to the end of a lane and waited."],
      "replies": [{ "id": "ok", "text": "Let me think." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.okafor.drafts",
      "speaker": "okafor",
      "lines": [
        "Three drafts. Rev. 1 had the two years in it. Rev. 2 had them struck out.",
        "The one I signed isn't the one I believed."
      ],
      "replies": [{ "id": "ok", "text": "Let me think." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.okafor.named",
      "speaker": "okafor",
      "lines": ["Then I'll come with you. I've been packed for thirty years."],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.okafor.anonymous",
      "speaker": "okafor",
      "lines": ["Thank you. Kell's people will move me. Don't ask where."],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.kell.warning",
      "speaker": "kell",
      "lines": [
        "Tethys survey traffic on the old relay lane. Two hulls, slow passes, transponders on.",
        "If your old man is still out there, he won't be for long."
      ],
      "replies": [{ "id": "ok", "text": "I'm on my way." }, { "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.kell.custody",
      "speaker": "kell",
      "lines": [
        "They took him. No shots. A transport, Tethys colours, on the scheduled run to their headquarters.",
        "It holds a route. I can give you the route."
      ],
      "replies": [{ "id": "route", "text": "Give me the route." }, { "id": "leave", "text": "Leave him. I can't." }]
    },
    {
      "id": "m3.okafor.rescued",
      "speaker": "okafor",
      "lines": ["You came. I didn't think anyone would read far enough to come."],
      "replies": [{ "id": "close", "text": "(close the channel)" }]
    },
    {
      "id": "m3.kell.lost",
      "speaker": "kell",
      "lines": [
        "The transport docked. He's on their books now. We won't get him back.",
        "He left notes with us. Not much. It's what there is."
      ],
      "replies": [{ "id": "ok", "text": "Send them." }, { "id": "close", "text": "(close the channel)" }]
    }
  ]
}
